import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1003"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4.883 12.621c0 .63.553 1.277 1.236 1.277.683 0 1.236-.647 1.236-1.277 0-.838-1.236-2.141-1.236-2.141s-1.236 1.291-1.236 2.141zm-3.86 0c0 .63.553 1.277 1.236 1.277.683 0 1.236-.647 1.236-1.277 0-.838-1.236-2.141-1.236-2.141s-1.236 1.291-1.236 2.141zm7.717 0c0 .63.553 1.277 1.236 1.277.683 0 1.236-.647 1.236-1.277 0-.838-1.236-2.141-1.236-2.141S8.74 11.771 8.74 12.621zm3.857 0c0 .63.553 1.277 1.236 1.277s1.236-.647 1.236-1.277c0-.838-1.236-2.141-1.236-2.141s-1.236 1.291-1.236 2.141zm1.378-7.475a2.928 2.928 0 0 0-1.75-1.13c-.178-1.577-1.452-2.741-2.859-2.762-1.123-.017-2.192.697-2.695 1.804a2.89 2.89 0 0 0-1.362.553 2.887 2.887 0 0 0-.878 1.082c-1.165-.155-1.991.455-2.353 1.182a1.705 1.705 0 0 0-1.207.13c-.49.259-.873.79-.873 1.414-.001.709.491 1.289 1.08 1.51.73.274 1.378-.09 1.468-.143.169.144.792.638 1.717.639a2.667 2.667 0 0 0 1.473-.45 3.9 3.9 0 0 0 2.195.368 3.861 3.861 0 0 0 1.665-.63 3.48 3.48 0 0 0 2.071.63 3.42 3.42 0 0 0 1.597-.449c.122.057.826.374 1.582.056.768-.323 1.194-1.135 1.156-1.874-.05-.969-.898-1.831-2.027-1.93z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }